import { ServiceContentById } from '@/api';
import { SharedDialog } from '@/components/dialog';
import { DialogProvider } from '@/contexts/dialog-context';
import { ServiceProvider } from '@/contexts/service-context';

import { PdpWidgetWrapper } from './pdp-widget-wrapper';

export function PdpRootWidget({
  serviceContentById,
}: {
  serviceContentById: ServiceContentById;
}) {
  if (!serviceContentById) return;
  return (
    <ServiceProvider serviceContentById={serviceContentById}>
      <DialogProvider>
        <PdpApp />
      </DialogProvider>
    </ServiceProvider>
  );
}

const PdpApp = () => (
  <>
    <PdpWidgetWrapper />
    <SharedDialog />
  </>
);
